import React, {useContext, useEffect, useState} from "react";

import {DealContext} from "../context";

import InputCustom from "views/pages/components/InputCustom";
import {InputArraySelect, InputKeySelect,} from "views/pages/components/InputSelect";
import axios from "axios";
import * as constants from "../../../../constants";
import Cookies from "js-cookie";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    FormGroup,
    Input,
    Modal,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import TableCustom from "../../components/TableCustom";

import {CURRENCY, validateForm} from 'constants/index.js';
import {useHistory} from 'react-router-dom';

import EmailsTab from '@pages/deals/tabs/EmailsTab';
import Score from "./details/Score";
import {ButtonContainer, Line} from "@pages/reusable-components/styled-components";
import {useDispatch} from "react-redux";
import actions from "actions/index.js";
import NotesListComponent from "@pages/components/NotesListComponent";
import DealInfoTab from "@pages/deals/tabs/components/DealInfoTab";
import CustomerInfoTab from "@pages/deals/tabs/components/CustomerInfoTab";
import VehicleInfoTab from "@pages/deals/tabs/components/VehicleInfoTab";
import CompanyInfoTab from "@pages/deals/tabs/components/CompanyInfoTab";

export default function InfoTab() {
  const dealContext = useContext(DealContext);
  const dispatch = useDispatch();

  const history = useHistory();
  const {
    businessTypes,
    companyTypes,
    dealChecksheet,
    dealStatuses,
    dealMileageIntervals,
    deal,
    titles,
    paymentIntervals,
    company,
    deliveredStatuses,
    customer,
    vehicle,
    dealErrors,
    transitModal,
    setTransitModal,
    updateDeal,
    defaulter,
    expired,
    id,
    formatDate,
    updateMileagePayment,
    profileData
  } = dealContext;

  const [tab, setTab] = useState("notes");
  const clearMenus = () => {
    dispatch(actions.setMenusList([]))
    dispatch(actions.setMenuName(null))
    dispatch(actions.setActiveMenu(null))
    history.push(`/admin/deals`)
  }
  const getDocument = async (id) => {
    if (Cookies.get('grs_token')) {
      let token = Cookies.get('grs_token');
      await axios({
        method: 'GET',
        url: constants.API_URL + '/live-vehicles-detail/' + id + '/deal-pdf-report',
        headers: {
          Authorization: 'Bearer ' + token
        },
        responseType: 'blob'
      })
        .then(response => {
          if (response.status === 200) {
            let data = response.data;
            const disposition = response.request.getResponseHeader('Content-Disposition');
            let fileName = "";
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            }
            const blob = new Blob([data])
            const downloadUrl = URL.createObjectURL(blob)
            let a = window.document.createElement("a");
            a.href = downloadUrl;
            a.download = fileName;
            window.document.body.appendChild(a);
            a.click();
          }
        })
        .catch(error => {
          console.error('error :: ', error.response);
        })
    }

  }

  return (
    <CardBody>
      {deal.id &&
      <Row>
        <Col lg={8} sm={12}>
          <Row  style={{
            marginLeft: '12px',
            gap: '25px'
          }}>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                className={'nav-text'}
                onClick={() => setTab("notes")}
                style={{ color: tab === "notes" && '#ec6409' }}
            >
              Notes
            </span>
              {tab === "notes" && <Line color={'#ec6409'} />}
            </div>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span onClick={() => setTab("deal")}
                  className={'nav-text'}
                  style={{ color: tab === "deal" && '#ec6409' }}>
              Deal info
            </span>
              {tab === "deal" && <Line color={'#ec6409'} />}
            </div>

            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                onClick={() => setTab("customer")}
                className={'nav-text'}
                style={{ color: tab === "customer" && '#ec6409' }}
            >
              Customer info
            </span>
              {tab === "customer" && <Line color={'#ec6409'} />}
            </div>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                onClick={() => setTab("vehicle")}
                className={'nav-text'}
                style={{ color: tab === "vehicle" && '#ec6409' }}
            >
              Vehicle info
            </span>
              {tab === "vehicle" && <Line color={'#ec6409'} />}
            </div>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                onClick={() => setTab("company")}
                className={'nav-text'}
                style={{ color: tab === "company" && '#ec6409' }}
            >
              Company info
            </span>
              {tab === "company" && <Line color={'#ec6409'} />}
            </div>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                onClick={() => setTab("activity")}
                className={'nav-text'}
                style={{ color: tab === "activity" && '#ec6409' }}
            >
              Activity
            </span>
              {tab === "activity" && <Line color={'#ec6409'} />}
            </div>
            <div
                className={`navbar-nav`}
                style={{
                  margin: 5,
                }}
            >
            <span
                className={'nav-text'}
                onClick={() => setTab("emails")}
                style={{ color: tab === "emails" && '#ec6409' }}
            >
              Emails
            </span>
              {tab === "emails" && <Line color={'#ec6409'} />}
            </div>

          </Row>
        </Col>
        <Col lg={4}>
            <h4>
              Account Manager - {customer?.account_manager}
            </h4>

        </Col>
      </Row>
      }
      {tab === "deal" && (
          <DealInfoTab
              deal={deal}
              dealErrors={dealErrors}
              dealChecksheet={dealChecksheet}
              deliveredStatuses={deliveredStatuses}
              paymentIntervals={paymentIntervals}
              dealStatuses={dealStatuses}
              updateDeal={(data) => updateDeal(data)}
              clearMenus={clearMenus}
              defaulter={defaulter}
              expired={expired}
              getDocument={getDocument}
              setTransitModal={setTransitModal}
          />
      )
      }
      {
        tab === "customer" && (
          <CustomerInfoTab initialCustomer={customer} titles={titles} updateDeal={updateDeal} clearMenus={clearMenus}/>
        )
      }
      {
        tab === "vehicle" && (
            <VehicleInfoTab clearMenus={clearMenus} updateDeal={updateDeal}
                            deal={{vehicle_make: deal.vehicle_make, vehicle_model: deal.vehicle_model,extras: deal.extras,current_mileage: deal.current_mileage}} initialVehicle={vehicle} dealMileageIntervals={dealMileageIntervals} />
        )
      }
      {
          tab === "notes" && (
            <NotesListComponent
             type={'debt'}
             userId={profileData.id}
             customerId={customer.id}
             dealId={deal.id}
            />
              )
      }
      {
        tab === "company" && (
              <CompanyInfoTab
                  company={company}
                  businessTypes={businessTypes}
                  companyTypes={companyTypes}
                  updateDeal={updateDeal}
                  clearMenus={clearMenus}
              />
        )
      }
      {
        tab === "activity" && (
          <Card>
            <CardHeader>
              <h2>Mileage activity</h2>
            </CardHeader>
            <CardBody>
              {dealMileageIntervals.length ? <TableCustom
                  loading={false}
                  items={dealMileageIntervals}
                  keyField={`title`}
                  searchField={true}
                  columns={[
                    {
                      dataField: "from_date",
                      text: "From",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return formatDate(row.from_date)
                      }
                    },
                    {
                      dataField: "to_date",
                      text: "To",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return formatDate(row.end_date)
                      }
                    },
                    {
                      dataField: "total_interval_miles",
                      text: "Mileage",
                      sort: true
                    },
                    {
                      dataField: "exceeded_at",
                      text: "Exceeded On",
                      sort: false,
                      formatter: (rowContent, row) => {
                        return formatDate(row.exceeded_at)
                      }
                    },
                    {
                      dataField: "exceeded_by",
                      text: "Exceeded By",
                      sort: false,
                      formatter: (rowContent, row) => {
                        return row.exceeded_at ? (row.total_interval_miles - deal.annual_mileage) : '-';
                      }
                    },
                    {
                      dataField: "exceeded_by",
                      text: "Cost",
                      sort: false,
                      formatter: (rowContent, row) => {
                        return row.exceeded_at ? `${CURRENCY} ${(Math.round(((row.total_interval_miles - deal.annual_mileage) * 0.2) * 100) / 100).toFixed(2)}` : '-';
                      }
                    },
                    {
                      dataField: "is_exceeded_paid",
                      text: "Invoiced",
                      sort: false,
                      formatter: (rowContent, row) => {
                        return row.exceeded_at ? (row.is_exceeded_paid === true ? "Yes" : "No") : '-';
                      }
                    },
                    {
                      dataField: "",
                      text: "",
                      formatter: (rowContent, row) => {
                        return (
                            <>
                              {row.exceeded_at && <UncontrolledDropdown>
                                <DropdownToggle
                                    className="btn-icon-only text-light"
                                    color=""
                                    role="button"
                                    size="sm"
                                >
                                  <i className="fas fa-ellipsis-v"/>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                  <DropdownItem
                                      onClick={() => updateMileagePayment(row)}
                                  >
                                    {(row.is_exceeded_paid === true ? "Not Paid" : "Paid")}
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                              }
                            </>
                        )
                      }
                    }
                  ]}
              /> : <h3>No activity yet</h3>}
            </CardBody>
            {(deal && deal.device) && <Score deal={id} deliveryDate={deal.delivery_date ?? null} />}
          </Card>
        )
      }
      {
        tab === "emails" && (
          <EmailsTab />
        )
      }
      <Modal
        isOpen={transitModal.show}
        toggle={() =>
          setTransitModal({
            ...transitModal,
            show: false,
          })
        }
        className="modal-dialog-centered"
      >
        <div className="modal-header">
          <h2 className="modal-title">{transitModal.header}</h2>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() =>
              setTransitModal({
                ...transitModal,
                show: false,
              })
            }
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">{transitModal.body}</div>
        <div className="modal-footer">
          <Button
            className="new-event--add"
            color="danger"
            type="button"
            onClick={transitModal.onClick}
          >
            {`Proceed`}
          </Button>
          <Button
            className="ml-auto"
            color="link"
            type="button"
            onClick={() =>
              setTransitModal({
                ...transitModal,
                show: false,
              })
            }
          >
            {`Cancel`}
          </Button>
        </div>
      </Modal>
    </CardBody >
  );
}
